export default (sitemap: SitemapBuilder) =>
{
    sitemap.before('[[[Moduły]]]', [
        {
            name: '[[[CMS]]]',
            short: '[[[CMS]]]',
            icon: 'fal fa-fw fa-globe',
            namespace: 'Ideo.Core.Edito.Application.Permissions.Cms',
            children: [
                {
                    name: '[[[Zarządzanie]]]',
                    header: true
                },
                {
                    name: '[[[Strony]]]',
                    route: 'cms-pages',
                    icon: 'far fa-fw fa-folder-tree',
                    auth: { all: ['PagesPermissions@View'], any: [] }
                },
                {
                    name: '[[[Aranżacje]]]',
                    route: 'cms-layouts',
                    icon: 'far fa-fw fa-objects-column',
                    auth: { all: ['LayoutsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie aranżacji]]]',
                            route: 'cms-layouts-add',
                            auth: { all: ['LayoutsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja aranżacji]]]',
                            route: 'cms-layouts-edit',
                            auth: { all: ['LayoutsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Witryny]]]',
                    route: 'cms-websites',
                    icon: 'far fa-fw fa-browsers',
                    auth: { all: ['WebsitesPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie witryny]]]',
                            route: 'cms-websites-add',
                            auth: { all: ['WebsitesPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja witryny]]]',
                            route: 'cms-websites-edit',
                            auth: { all: ['WebsitesPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Konfiguracja]]]',
                    header: true
                },
                {
                    name: '[[[Szablony]]]',
                    route: 'cms-themes',
                    icon: 'far fa-fw fa-sidebar',
                    auth: { all: ['ThemesPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie szablonu]]]',
                            route: 'cms-themes-add',
                            auth: { all: ['ThemesPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja szablonu]]]',
                            route: 'cms-themes-edit',
                            auth: { all: ['ThemesPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Shortcodes]]]',
                    route: 'cms-shortcode-types',
                    icon: 'far fa-fw fa-rectangle-code',
                    auth: { all: ['ShortCodesPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie wzoru]]]',
                            route: 'cms-shortcode-types-add',
                            auth: { all: ['ShortCodesPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja wzoru]]]',
                            route: 'cms-shortcode-types-edit',
                            auth: { all: ['ShortCodesPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Przekierowania]]]',
                    route: 'cms-redirections',
                    icon: 'fa-regular fa-right-left-large',
                    auth: { all: ['RedirectionsPermissions@View'], any: [] }
                },
                {
                    name: '[[[RSS]]]',
                    route: 'cms-rss',
                    icon: 'far fa-fw fa-square-rss',
                    auth: { all: ['RssPermissions@View'], any: [] }
                },
                {
                    name: '[[[Monitoring]]]',
                    header: true
                },
                {
                    name: '[[[Historia wyszukiwania]]]',
                    route: 'cms-search-history',
                    icon: 'far fa-fw fa-magnifying-glass',
                    auth: { all: ['AdminPermissions@Authlog'], any: [] }
                }
            ]
        }
    ]);

    sitemap.find('[[[Moduły]]]').push([
        {
            name: '[[[CMS]]]',
            header: true
        },
        {
            name: '[[[Artykuły]]]',
            icon: 'far fa-fw fa-newspaper',
            children: [
                {
                    name: '[[[Lista artykułów]]]',
                    route: 'cms-articles',
                    auth: { all: ['ArticlesPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie artykułu]]]',
                            route: 'cms-articles-add',
                            auth: { all: [], any: ['ArticlesPermissions@Edit', 'ArticlesPermissions@EditAll'] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja artykułu]]]',
                            route: 'cms-articles-edit',
                            auth: { all: [], any: ['ArticlesPermissions@Edit', 'ArticlesPermissions@EditAll'] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Kategorie]]]',
                    route: 'cms-articles-categories',
                    icon: 'far fa-fw fa-file-alt',
                    auth: { all: ['ArticlesCategoriesPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie kategorii]]]',
                            route: 'cms-articles-categories-add',
                            auth: { all: ['ArticlesCategoriesPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja kategorii]]]',
                            route: 'cms-articles-categories-edit',
                            auth: { all: ['ArticlesCategoriesPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Sortowanie kategorii]]]',
                            route: 'cms-articles-categories-sort',
                            auth: { all: ['ArticlesCategoriesPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Etykiety]]]',
                    route: 'cms-articles-labels',
                    icon: 'far fa-fw fa-file-alt',
                    auth: { all: ['ArticleLabelsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie etykiety]]]',
                            route: 'cms-articles-labels-add',
                            auth: { all: ['ArticleLabelsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja etykiety]]]',
                            route: 'cms-articles-labels-edit',
                            auth: { all: ['ArticleLabelsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Czołówka]]]',
                    route: 'cms-articles-headline-covers',
                    icon: 'far fa-fw fa-file-alt',
                    auth: { all: ['ArticlesHeadlineCoversPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie czołówki]]]',
                            route: 'cms-articles-headline-covers-add',
                            auth: { all: ['ArticlesHeadlineCoversPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja czołówki]]]',
                            route: 'cms-articles-headline-covers-edit',
                            auth: { all: ['ArticlesHeadlineCoversPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                }
            ]

        },
        {
            name: '[[[Autorzy]]]',
            route: 'cms-authors',
            icon: 'far fa-fw fa-user-vneck-hair',
            auth: { all: ['AuthorsPermissions@View'], any: [] },
            children: [
                {
                    name: '[[[Sortowanie autorów]]]',
                    route: 'cms-authors-sort',
                    auth: { all: ['AuthorsPermissions@Edit'], any: [] },
                    visible: false
                },
                {
                    name: '[[[Dodanie autora]]]',
                    route: 'cms-authors-add',
                    auth: { all: ['AuthorsPermissions@Edit'], any: [] },
                    visible: false
                },
                {
                    name: '[[[Edycja autora]]]',
                    route: 'cms-authors-edit',
                    auth: { all: ['AuthorsPermissions@Edit'], any: [] },
                    visible: false
                },
                {
                    name: '[[[Ustawienia redakcji]]]',
                    route: 'cms-authors-editor',
                    auth: { all: ['AuthorsPermissions@Edit'], any: [] },
                    visible: false
                }
            ]
        },
        {
            name: '[[[Aktualności]]]',
            route: 'cms-informations',
            icon: 'far fa-fw fa-radio-tuner',
            auth: { all: ['InformationsPermissions@View'], any: [] },
            children: [
                {
                    name: '[[[Dodanie aktualności]]]',
                    route: 'cms-informations-add',
                    auth: { all: [], any: ['InformationsPermissions@Edit', 'InformationsPermissions@EditAll'] },
                    visible: false
                },
                {
                    name: '[[[Edycja aktualności]]]',
                    route: 'cms-informations-edit',
                    auth: { all: [], any: ['InformationsPermissions@Edit', 'InformationsPermissions@EditAll'] },
                    visible: false
                }
            ]
        },
        {
            name: '[[[Pytania i odpowiedzi]]]',
            route: 'cms-faq',
            icon: 'far fa-fw fa-clipboard-question',
            auth: { all: ['FaqPermissions@View'], any: [] },
            children: [
                {
                    name: '[[[Dodanie poradnika]]]',
                    route: 'cms-faq-add',
                    auth: { all: [], any: ['FaqPermissions@Edit', 'FaqPermissions@EditAll'] },
                    visible: false
                },
                {
                    name: '[[[Edycja poradnika]]]',
                    route: 'cms-faq-edit',
                    auth: { all: [], any: ['FaqPermissions@Edit', 'FaqPermissions@EditAll'] },
                    visible: false
                }
            ]
        },
        {
            name: '[[[Ankiety]]]',
            route: 'cms-surveys',
            icon: 'far fa-fw fa-ballot-check',
            auth: { all: ['SurveysPermissions@View'], any: [] },
            children: [
                {
                    name: '[[[Dodanie ankiety]]]',
                    route: 'cms-surveys-add',
                    auth: { all: [], any: ['SurveysPermissions@Edit', 'SurveysPermissions@EditAll'] },
                    visible: false
                },
                {
                    name: '[[[Edycja ankiety]]]',
                    route: 'cms-surveys-edit',
                    auth: { all: [], any: ['SurveysPermissions@Edit', 'SurveysPermissions@EditAll'] },
                    visible: false
                }
            ]
        },
        {
            name: '[[[Tagi]]]',
            route: 'cms-tags',
            icon: 'far fa-fw fa-tags',
            auth: { all: ['TagsPermissions@View'], any: [] }
        },
        {
            name: '[[[Katalog linków]]]',
            icon: 'far fa-fw fa-link',
            children: [
                {
                    name: '[[[Lista linków]]]',
                    route: 'cms-link-links',
                    auth: { all: ['LinksPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie linku]]]',
                            route: 'cms-link-links-add',
                            auth: { all: [], any: ['LinksPermissions@Edit', 'LinksPermissions@EditAll'] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja linku]]]',
                            route: 'cms-link-links-edit',
                            auth: { all: [], any: ['LinksPermissions@Edit', 'LinksPermissions@EditAll'] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Kategorie linków]]]',
                    route: 'cms-link-categories',
                    auth: { all: ['LinkCategoriesPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie kategorii]]]',
                            route: 'cms-link-categories-add',
                            auth: { all: ['LinkCategoriesPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja kategorii]]]',
                            route: 'cms-link-categories-edit',
                            auth: { all: ['LinkCategoriesPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]

                }
            ]
        },
        {
            name: '[[[Baza dokumentów]]]',
            icon: 'far fa-fw fa-files',
            children: [
                {
                    name: '[[[Dokumenty]]]',
                    route: 'cms-documents',
                    auth: { all: ['DocumentsPermission@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie dokumentu]]]',
                            route: 'cms-documents-add',
                            auth: { all: [], any: ['DocumentsPermission@Edit', 'DocumentsPermission@EditAll'] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja dokumentu]]]',
                            route: 'cms-documents-edit',
                            auth: { all: [], any: ['DocumentsPermission@Edit', 'DocumentsPermission@EditAll'] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Kategorie]]]',
                    route: 'cms-documents-categories',
                    auth: { all: ['DocumentsCategoriesPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie kategorii]]]',
                            route: 'cms-documents-categories-add',
                            auth: { all: ['DocumentsCategoriesPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja kategorii]]]',
                            route: 'cms-documents-categories-edit',
                            auth: { all: ['DocumentsCategoriesPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                }
            ]
        },
        {
            name: '[[[Galeria zdjęć]]]',
            route: 'cms-gallery',
            icon: 'far fa-fw fa-image',
            auth: { all: ['PhotoGalleryPermissions@View'], any: [] },
            children: [
                {
                    name: '[[[Dodanie galerii]]]',
                    route: 'cms-gallery-add',
                    auth: { all: [], any: ['PhotoGalleryPermissions@Edit', 'PhotoGalleryPermissions@EditAll'] },
                    visible: false
                },
                {
                    name: '[[[Edycja galerii]]]',
                    route: 'cms-gallery-edit',
                    auth: { all: [], any: ['PhotoGalleryPermissions@Edit', 'PhotoGalleryPermissions@EditAll'] },
                    visible: false
                }
            ]
        },
        {
            name: '[[[Wideo]]]',
            route: 'cms-videos',
            icon: 'far fa-fw fa-video',
            auth: { all: ['VideosPermissions@View'], any: [] },
            children: [
                {
                    name: '[[[Dodanie wideo]]]',
                    route: 'cms-videos-add',
                    auth: { all: [], any: ['VideosPermissions@Edit', 'VideosPermissions@EditAll'] },
                    visible: false
                },
                {
                    name: '[[[Edycja wideo]]]',
                    route: 'cms-videos-edit',
                    auth: { all: [], any: ['VideosPermissions@Edit', 'VideosPermissions@EditAll'] },
                    visible: false
                }
            ]
        },
        {
            name: '[[[Rotatory opinii]]]',
            route: 'cms-opinion-sliders',
            auth: { all: ['OpinionSlidersPermissions@View'], any: [] },
            icon: 'fa-sharp fa-regular fa-comments',
            children: [
                {
                    name: '[[[Dodanie rotatora]]]',
                    route: 'cms-opinion-sliders-add',
                    auth: { all: ['OpinionSlidersPermissions@Edit'], any: [] },
                    visible: false
                },
                {
                    name: '[[[Edycja rotatora]]]',
                    route: 'cms-opinion-sliders-edit',
                    auth: { all: ['OpinionSlidersPermissions@Edit'], any: [] },
                    visible: false
                }
            ]
        },
        {
            name: '[[[Gazetka]]]',
            icon: 'far fa-fw fa-book-open',
            route: 'cms-flipping-book',
            auth: { all: ['FlippingbooksPermissions@View'], any: [] },
            children: [
                {
                    name: '[[[Dodanie gazetki]]]',
                    route: 'cms-flipping-book-add',
                    auth: { all: ['FlippingbooksPermissions@Edit'], any: [] },
                    visible: false
                },
                {
                    name: '[[[Edycja gazetki]]]',
                    route: 'cms-flipping-book-edit',
                    auth: { all: ['FlippingbooksPermissions@Edit'], any: [] },
                    visible: false
                }
            ]
        },
        {
            name: '[[[Studio]]]',
            header: true
        }
    ]);

    sitemap.after('[[[Moduły]]]', [
        {
            name: '[[[Marketing]]]',
            short: '[[[Marketing]]]',
            icon: 'fal fa-fw fa-chart-pie',
            namespace: 'Ideo.Core.Edito.Application.Permissions.Cms',
            children: [
                {
                    name: '[[[Subskrypcje]]]',
                    icon: 'fa-regular fa-envelope',
                    auth: { all: ['SubscriptionsPermissions@View'], any: [] },
                    route: 'cms-subscriptions'
                },
                {
                    name: '[[[Regulaminy]]]',
                    icon: 'far fa-fw fa-file-contract',
                    auth: { all: [], any: ['RegulationsSetsPermissions@View', 'RegulationsPermissions@View'] },
                    children: [
                        {
                            name: '[[[Lista regulaminów]]]',
                            route: 'cms-regulations',
                            auth: { all: ['RegulationsPermissions@View'], any: [] },
                            children: [
                                {
                                    name: '[[[Dodanie regulaminu]]]',
                                    route: 'cms-regulations-add',
                                    auth: { all: [], any: ['RegulationsPermissions@Edit', 'RegulationsPermissions@EditAll'] },
                                    visible: false
                                },
                                {
                                    name: '[[[Edycja regulaminu]]]',
                                    route: 'cms-regulations-edit',
                                    auth: { all: [], any: ['RegulationsPermissions@Edit', 'RegulationsPermissions@EditAll'] },
                                    visible: false
                                }
                            ]
                        },
                        {
                            name: '[[[Ustawienia]]]',
                            route: 'cms-regulations-sets',
                            auth: { all: ['RegulationsSetsPermissions@View'], any: [] },
                            children: [
                                {
                                    name: '[[[Dodanie zestawu regulaminów]]]',
                                    route: 'cms-regulations-sets-add',
                                    auth: { all: ['RegulationsSetsPermissions@Edit'], any: [] },
                                    visible: false
                                },
                                {
                                    name: '[[[Edycja zestawu regulaminów]]]',
                                    route: 'cms-regulations-sets-edit',
                                    auth: { all: ['RegulationsSetsPermissions@Edit'], any: [] },
                                    visible: false
                                }
                            ]
                        }
                    ]
                },
                {
                    name: '[[[Komentarze]]]',
                    icon: 'far fa-fw fa-messages',
                    auth: { all: ['CommentsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Lista komentarzy]]]',
                            route: 'cms-comments',
                            auth: { all: ['CommentsPermissions@View'], any: [] },
                            children: [
                                {
                                    name: '[[[Edycja komentarza]]]',
                                    route: 'cms-comments-edit',
                                    auth: { all: ['CommentsPermissions@Edit'], any: [] },
                                    visible: false
                                }
                            ]
                        },
                        {
                            name: '[[[Ustawienia]]]',
                            route: 'cms-comments-sets',
                            auth: { all: ['CommentsSetsPermissions@View'], any: [] },
                            children: [
                                {
                                    name: '[[[Edycja ustawień]]]',
                                    route: 'cms-comments-sets-edit',
                                    auth: { all: ['CommentsSetsPermissions@Edit'], any: [] },
                                    visible: false
                                }
                            ]
                        }
                    ]
                },
                {
                    name: '[[[Top tematy]]]',
                    route: 'cms-top-topics',
                    icon: 'far fa-fw fa-window-restore',
                    auth: { all: ['TopTopicsPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie top tematu]]]',
                            route: 'cms-top-topics-add',
                            auth: { all: ['TopTopicsPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja top tematu]]]',
                            route: 'cms-top-topics-edit',
                            auth: { all: ['TopTopicsPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Linki wewnętrzne]]]',
                    route: 'cms-internal-links',
                    icon: 'far fa-fw fa-link',
                    auth: { all: ['InternalLinksPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie linku wewnętrznego]]]',
                            route: 'cms-internal-links-add',
                            auth: { all: ['InternalLinksPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja linku wewnętrznego]]]',
                            route: 'cms-internal-links-edit',
                            auth: { all: ['InternalLinksPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Banery]]]',
                    icon: 'far fa-fw fa-billboard',
                    children: [
                        {
                            name: '[[[Lista banerów]]]',
                            route: 'cms-banners',
                            auth: { all: ['BannersPermissions@View'], any: [] },
                            children: [
                                {
                                    name: '[[[Dodanie baneru]]]',
                                    route: 'cms-banners-add',
                                    auth: { all: ['BannersPermissions@Edit'], any: [] },
                                    visible: false
                                },
                                {
                                    name: '[[[Edycja baneru]]]',
                                    route: 'cms-banners-edit',
                                    auth: { all: ['BannersPermissions@Edit'], any: [] },
                                    visible: false
                                }
                            ]
                        },
                        {
                            name: '[[[Grupy]]]',
                            route: 'cms-banner-groups',
                            auth: { all: ['BannerGroupsPermissions@View'], any: [] },
                            children: [
                                {
                                    name: '[[[Dodanie grupy]]]',
                                    route: 'cms-banner-groups-add',
                                    auth: { all: ['BannerGroupsPermissions@Edit'], any: [] },
                                    visible: false
                                },
                                {
                                    name: '[[[Edycja grupy]]]',
                                    route: 'cms-banner-groups-edit',
                                    auth: { all: ['BannerGroupsPermissions@Edit'], any: [] },
                                    visible: false
                                }
                            ]
                        }
                    ]

                },
                {
                    name: '[[[Slajdery]]]',
                    route: 'cms-sliders',
                    icon: 'far fa-fw fa-columns-3',
                    auth: { all: ['SlidersPermissions@View'], any: [] },
                    children: [
                        {
                            name: '[[[Dodanie slajdera]]]',
                            route: 'cms-sliders-add',
                            auth: { all: ['SlidersPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja slajdera]]]',
                            route: 'cms-sliders-edit',
                            auth: { all: ['SlidersPermissions@Edit'], any: [] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[RSS]]]',
                    route: 'cms-rss',
                    icon: 'far fa-fw fa-square-rss',
                    auth: { all: ['RssPermissions@View'], any: [] }
                }
            ]
        },
        {
            name: '[[[Premium]]]',
            short: '[[[Premium]]]',
            icon: 'fa-light fa-file-invoice-dollar',
            namespace: 'Ideo.Core.Edito.Application.Permissions.Premium',
            children: [
                {
                    name: '[[[Zamówienia]]]',
                    icon: 'fa-regular fa-receipt',
                    auth: { all: ['OrdersPremissions@View'], any: [] },
                    route: 'premium-orders',
                    children: [
                        {
                            name: '[[[Szczegóły zamówienia]]]',
                            route: 'premium-orders-view',
                            auth: { all: [], any: ['OrdersPremissions@View'] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Klienci]]]',
                    icon: 'fa-regular fa-user-group-simple',
                    auth: { all: ['CustomersPermissions@View'], any: [] },
                    route: 'premium-customers',
                    children: [
                        {
                            name: '[[[Szczegóły klienta]]]',
                            route: 'premium-customers-view',
                            auth: { all: [], any: ['CustomersPermissions@View'] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Pakiety]]]',
                    icon: 'fa-regular fa-cubes',
                    auth: { all: ['PackagesPermissions@View'], any: [] },
                    route: 'premium-packages',
                    children: [
                        {
                            name: '[[[Sortowanie pakietów]]]',
                            route: 'premium-packages-sort',
                            auth: { all: ['PackagesPermissions@Edit'], any: [] },
                            visible: false
                        },
                        {
                            name: '[[[Dodanie pakietu]]]',
                            route: 'premium-packages-add',
                            auth: { all: [], any: ['PackagesPermissions@Edit'] },
                            visible: false
                        },
                        {
                            name: '[[[Edycja pakietu]]]',
                            route: 'premium-packages-edit',
                            auth: { all: [], any: ['PackagesPermissions@Edit'] },
                            visible: false
                        }
                    ]
                },
                {
                    name: '[[[Konfiguracja]]]',
                    icon: 'far fa-fw fa-sliders',
                    auth: { all: [], any: ['SettingsPermissions@View'] },
                    children: [
                        {
                            name: '[[[Ustawienia płatności]]]',
                            route: 'premium-settings',
                            auth: { all: ['SettingsPermissions@View'], any: [] }
                        },
                        {
                            name: '[[[Zamówienia]]]',
                            route: 'premium-settings-orders',
                            auth: { all: ['SettingsPermissions@View'], any: [] }
                        },
                        {
                            name: '[[[Powiadomienia]]]',
                            route: 'premium-settings-notifications',
                            auth: { all: ['SettingsPermissions@View'], any: [] }
                        }
                    ]
                }
            ]
        }
    ]);
};
